import getHelper from '../../../services/getHelper';
import type { ReferenceSkill } from '../../../../../index';

export default getHelper<ReferenceSkill>('/reference-skills');
